import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@alfalab/core-components/typography';
export const Text = ({ text, componentSize, colorText }) => {
    if (Number(componentSize) >= 80) {
        return (_jsx(Typography.Title, { view: 'small', tag: 'div', color: colorText, children: text }));
    }
    if (Number(componentSize) === 64) {
        return (_jsx(Typography.Text, { view: 'primary-large', weight: 'bold', color: colorText, children: text }));
    }
    return (_jsx(Typography.Text, { view: 'primary-small', weight: 'bold', color: colorText, children: text }));
};
